import { Injectable, inject } from '@angular/core';
import { APP_BASE_HREF, HashLocationStrategy, PlatformLocation } from '@angular/common';

@Injectable()
export class CustomLocationStrategyService extends HashLocationStrategy {
  private _baseHashHref = '';
  private platformLocation: PlatformLocation;

  constructor() {
    const _platformLocation = inject(PlatformLocation);
    const _baseHref = inject(APP_BASE_HREF, { optional: true });

    super(_platformLocation, _baseHref);

    if (_platformLocation) {
      this.platformLocation = _platformLocation;
    }
  }

  public override prepareExternalUrl(internal: string): string {
    return this._baseHashHref + '#' + internal;
  }

  public override getBaseHref(): string {
    if (this.platformLocation) {
      this._baseHashHref = '/' + this.platformLocation.pathname + this.platformLocation.search;

      if (this._baseHashHref.startsWith('//')) {
        this._baseHashHref = this._baseHashHref.slice(1);
      }
    }

    return this._baseHashHref;
  }
}
